export default "__VITE_ASSET__Bus6SFrl__ 40w, __VITE_ASSET__BNhVt5VH__ 80w, __VITE_ASSET__EnVdcTfy__ 120w";